import { Stack } from '@mui/material'
import { preview } from '@/components/form/preview'
import { useOrderPriorityTexts } from '@/intl'
import {
  ExpandLess,
  ExpandMore,
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowUp,
  UnfoldMore,
} from '@mui/icons-material'
import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function Priority(props: Props) {
  const {
    extOrder: {
      order: { priority },
    },
  } = props

  const texts = useTexts()
  const { getPriorityText } = useOrderPriorityTexts()

  return (
    <preview.Field label={texts.priority.label}>
      <Stack direction="row" alignItems="center" gap={1} flexGrow={1}>
        <PriorityIcon priority={priority} />
        {getPriorityText(priority)}
      </Stack>
    </preview.Field>
  )
}

type PriorityIconProps = {
  priority: uui.domain.server.rm.BaseOrder['priority']
}

function PriorityIcon(props: PriorityIconProps) {
  const { priority } = props

  switch (priority) {
    // highest priority
    case 20:
      return <KeyboardDoubleArrowUp sx={{ color: t => t.vars.palette.error.main }} />

    // higher priority
    case 10:
      return <ExpandLess sx={{ color: t => t.vars.palette.warning.main }} />

    // normal priority
    case 0:
      return <UnfoldMore sx={{ color: t => t.vars.palette.action.active }} />

    // lower priority
    case -10:
      return <ExpandMore sx={{ color: t => t.vars.palette.info.main }} />

    // lowest priority
    case -20:
      return <KeyboardDoubleArrowDown sx={{ color: t => t.vars.palette.success.main }} />
  }
}
